// tempexp_18907-full-file
import React, { memo, useEffect, useState } from 'react';
import { discountInOutflowLogger } from 'reactApp/ui/DiscountInOutflow/DiscountInOutflow.const';
import { formatDuration } from 'reactApp/utils/timeHelpers';

export interface TimerProps {
    durationF: any;
    handleEnd: () => void;
}

export const Timer = memo<TimerProps>(({ durationF, handleEnd }) => {
    const [seconds, setSeconds] = useState(0);

    discountInOutflowLogger.info('timer render');
    useEffect(() => {
        let interval;

        const restart = () => {
            discountInOutflowLogger.info('timer restart');

            clearInterval(interval);
            setSeconds(durationF());
            interval = setInterval(() => {
                setSeconds((prevSeconds) => prevSeconds - 1);
            }, 1000);
        };

        const onVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                restart();
            }
        };

        discountInOutflowLogger.info('addVisibilityChange');
        document.addEventListener('visibilitychange', onVisibilityChange);

        restart();

        return () => {
            discountInOutflowLogger.info('removeVisibilityChange');
            clearInterval(interval);
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, [durationF]);

    useEffect(() => {
        if (seconds < 0) {
            handleEnd();
        }
    }, [seconds]);

    return <>{formatDuration(seconds)}</>;
});

Timer.displayName = 'Timer';
